import { formatError } from "../axiosClient";
import { USED_APPLICATION_CAPABILITY_EVENT_NAME } from "./constants";
import databricksLogger from "./databricksLogger";
import sendEvent from "./sendEvent";
/**
 * Says "the User used this Feature": one call, one `used_application_capability` event with the key.
 * Fire-and-forget. It is never awaited, and a failed send is logged at debug level and swallowed, so a
 * broken event pipeline can never break a page.
 */
export default function sendCapabilityUsedEvent(capabilityKey) {
    sendEvent({ eventName: USED_APPLICATION_CAPABILITY_EVENT_NAME, fields: { capability_key: capabilityKey } }).catch((sendError) => {
        databricksLogger.debug(`Usage event for '${capabilityKey}' failed: ${formatError(sendError)}`);
    });
}
